export default "__VITE_ASSET__By04knwA__"